import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'
import white from '../Img/White-bg.png'

function Shuffle() {
  return (
    <div>
         <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg'>Shuffle</h1>
      </div>
      <div className='flex flex-col justify-center rounded-lg py-14 items-center mt-[60px] mx-[24px] w-[325px] h-[382px] bg-[#D3F36B]'>
        <div className='flex flex-col'>
        <img className='w-[80px] ' src={white} alt="" />
        <p className='flex items-center justify-center mt-3 mb-[24px]'>Bob</p>
        </div>
        <h3 className='w-44 text-center font-bold'>Shuffle to connect with random people</h3>
      </div>
      <div className='flex flex-col mt-[40px] justify-center items-center'>
        <h2 className='font-bold text-[17px]'>Meet Random People</h2>
        <p className='text-[12px] text-gray-500'>Powered by Chinlink VRF</p>
        <Link to='/aftershuffle'  className='px-4 py-2 bg-black text-white rounded-3xl font-bold text-[16px] mt-4'>Shuffle</Link>
      </div>
      <Footer active='shuffle'/>
    </div>
  )
} 

export default Shuffle